// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA-Bxa2lQMeCbpe309UDwTSFhbNa4S0Msw",
    authDomain: "tlabs-api.firebaseapp.com",
    databaseURL: "https://tlabs-api.firebaseio.com",
    projectId: "tlabs-api",
    storageBucket: "",
    messagingSenderId: "935262488148",
    appId: "1:935262488148:web:3b18a9e7d16ee552"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
